export default __webpack_public_path__ + "static/media/pic3.3f102b1e.jpg";